/* eslint-disable @typescript-eslint/strict-boolean-expressions */
// istanbul ignore file
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useWebSocket } from '../../../contexts/WebSocketContext'
import { type DeviceStatusOnlineDataState, DeviceStatusOnlineWebSocketUpdateAction } from '../redux/getDeviceStatusOnlineSlice'
import type { DashboardDeviceStatusUpdate } from '../../../types/websocket.types'
import { type ConnectedProps, connect } from 'react-redux'
import { type RootState } from '../../../store'

const DeviceStatus = (props: AllProps): JSX.Element => {
  const dispatch = useDispatch()
  const [isOnline, setIsOnline] = useState<boolean | undefined>(false)
  const [lastProcessedDeviceStatusMessageId, setLastProcessedDeviceStatusMessageId] = useState<string | null>(null)
  const { isConnected, messages, subscribeToDeviceStatus } = useWebSocket()
  const [subscribedDeviceStatusDeviceId, setSubscribedDeviceStatusDeviceId] = useState<string | null>(null)

  // Monitor device online status
  useEffect(() => {
    if (props.DeviceStatusOnlineData !== undefined) {
      setIsOnline(Boolean(props.DeviceStatusOnlineData.DeviceStatusOnlineData?.is_asset_online))
    }
  }, [props.DeviceStatusOnlineData])

  useEffect(() => {
    if (isConnected && props.parentDeviceId !== undefined && props.parentDeviceId !== null && props.parentDeviceId !== '') {
      // Subscribe to device status updates
      if (subscribedDeviceStatusDeviceId !== props.parentDeviceId) {
        subscribeToDeviceStatus(props.parentDeviceId)
          .then((response: any) => {
            setSubscribedDeviceStatusDeviceId(props.parentDeviceId)
          })
          .catch((error: any) => {
            console.error('Failed to subscribe to device status:', error)
          })
      }
    } else {
      if (subscribedDeviceStatusDeviceId !== null) {
        setSubscribedDeviceStatusDeviceId(null)
      }
    }
  }, [isConnected, props.parentDeviceId, subscribedDeviceStatusDeviceId])

  // Process WebSocket KPI and Modbus messages
  useEffect(() => {
    if (messages.length > 0) {
      const latestMessage = messages[messages.length - 1]
      // Check if the latest message is a HEARTBEAT and return early
      if (latestMessage?.type === 'HEARTBEAT') {
        return
      }

      // Create a unique message ID based on data content
      const messageId = latestMessage.correlationId ??
            `${latestMessage.type}-${JSON.stringify(latestMessage.data)}`

      // Handle device status updates
      if (latestMessage.type === 'DASHBOARD_DEVICE_STATUS_UPDATE' && Boolean(latestMessage.data)) {
        // Skip if we've already processed this exact message content
        if (messageId === lastProcessedDeviceStatusMessageId) {
          return
        }

        const data = latestMessage.data as DashboardDeviceStatusUpdate

        // Dispatch Redux action to update device status

        dispatch(DeviceStatusOnlineWebSocketUpdateAction(data))

        // Update local online status state
        setIsOnline(data.is_asset_online)

        setLastProcessedDeviceStatusMessageId(messageId)
      }
    }
  }, [messages.length, lastProcessedDeviceStatusMessageId])

  return (
    <>
        <div
            style={{
              fontSize: '16px',
              marginRight: '10px',
              textAlign: 'right',
              fontWeight: 'bold',
              marginTop: '10px',
              color: '#F0F0F0',
              textTransform: 'uppercase',
              letterSpacing: '2.5px'
            }}
        >
            DEVICE STATUS :{' '}
            <span
            style={{
              color: isOnline === true ? '#68D560' : '#EE3124'
            }}
            >
            {isOnline === true ? 'Online' : 'Offline'}
            </span>
        </div>
    </>
  )
}
interface StateToProps {
  DeviceStatusOnlineData: DeviceStatusOnlineDataState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  DeviceStatusOnlineData: state.DeviceStatusOnlineData
})
const connector = connect(mapStateToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

interface InputsParms {
  parentDeviceId: string
}

type AllProps = PropsFromRedux & InputsParms

export const MemoDeviceStatus = React.memo(connector(DeviceStatus))
